define([
    "skylark-utils/eventer"
], function(eventer) {
    return eventer;
});
